import createReducer from '../../utils/createReducer';
import { APP_LOADING } from '../../actions/app/appActionConstants';

const initialState = {
  [APP_LOADING]: true,
};
export default createReducer(
  {
    UPDATE_LOADER: updateLoader,
    [APP_LOADING]: updateAppReadyLoader,
  },
  initialState,
);

function updateLoader(state, action) {
  return {
    ...state,
    [action.payload.actionType]: action.payload.isLoading,
  };
}

function updateAppReadyLoader(state) {
  return {
    ...state,
    [APP_LOADING]: false,
  };
}
